import projectsSlice from './projectsSlice';

export const {
  setProjectScaffold,
  setEmployeeMap,
  setMaps
} = projectsSlice.actions;

export default projectsSlice;
